import variantsService from './variantsService'

export default variantsService



// WEBPACK FOOTER //
// ../src/services/variantsService/index.js